import React from "react";
import { Link } from "react-router-dom";
import { FiArrowUpRight, FiCheck } from "react-icons/fi";
import WebsiteFeatureCart from "./WebsiteFeatureCart";

const webFeatures = [
  {
    image: "/Images/reponsive-web-design.png",
    heading: "Responsive websites",
    description:
      "A seamless experience across phones, tablets, laptops, and every screen in between.",
  },
  {
    image: "/Images/seo-friendly.png",
    heading: "SEO-friendly foundations",
    description:
      "Clean structure and search-ready development that help customers discover your website.",
  },
  {
    image: "/Images/chat-social-integration.png",
    heading: "Chat and social integration",
    description:
      "Connect your channels and give visitors faster, more convenient ways to reach your team.",
  },
  {
    image: "/Images/inquiry-form-integration.png",
    heading: "Smart inquiry forms",
    description:
      "Turn visitor interest into qualified conversations with clear, purposeful lead forms.",
  },
  {
    image: "/Images/blog-integration.png",
    heading: "Flexible blog integration",
    description:
      "Publish useful content easily, strengthen authority, and keep your audience coming back.",
  },
  {
    image: "/Images/cstmize-theme-integration.png",
    heading: "Custom brand experience",
    description:
      "A tailored visual system that feels consistent, distinctive, and unmistakably yours.",
  },
];

const WebsiteFeature = () => {
  return (
    <section className="relative isolate overflow-hidden bg-[#080b12] px-5 py-20 text-white md:px-8 md:py-24 lg:px-12 lg:py-28">
      <div className="absolute inset-0 -z-30 bg-[radial-gradient(circle_at_8%_12%,rgba(100,60,144,0.4),transparent_25%),radial-gradient(circle_at_92%_82%,rgba(35,155,230,0.14),transparent_28%)]" />
      <div className="absolute inset-0 -z-20 opacity-[0.055] [background-image:linear-gradient(rgba(255,255,255,0.45)_1px,transparent_1px),linear-gradient(90deg,rgba(255,255,255,0.45)_1px,transparent_1px)] [background-size:64px_64px]" />
      <div className="absolute -left-24 top-20 -z-10 h-64 w-64 rounded-full border border-white/10" />
      <div className="absolute -right-20 bottom-12 -z-10 h-56 w-56 rounded-full border border-[#FFDB16]/15" />

      <div className="mx-auto max-w-7xl">
        <div className="grid items-end gap-7 lg:grid-cols-[1.05fr_0.95fr] lg:gap-16">
          <div>
            <div className="inline-flex items-center gap-3 rounded-full border border-white/10 bg-white/[0.06] px-4 py-2 backdrop-blur-xl">
              <span className="h-2.5 w-2.5 rounded-full bg-[#FFDB16] shadow-[0_0_18px_rgba(255,219,22,0.65)]" />
              <span className="text-sm font-bold tracking-wide text-slate-200">
                Built-in capabilities
              </span>
            </div>
            <h2 className="mt-6 max-w-3xl font-heading text-4xl font-extrabold leading-[1.08] tracking-[-0.04em] text-white md:text-5xl lg:text-[3.6rem]">
              Web development features that
              <span className="block text-[#FFDB16]">work harder for you.</span>
            </h2>
          </div>

          <p className="max-w-2xl text-lg leading-8 text-slate-300 lg:pb-1">
            We build the essential capabilities into your website from the
            beginning—so it is easier to discover, effortless to use, and ready
            to support your next stage of growth.
          </p>
        </div>

        <div className="mt-12 grid gap-4 md:grid-cols-2 lg:mt-14 lg:grid-cols-3 lg:gap-5">
          {webFeatures.map((feature, index) => (
            <WebsiteFeatureCart
              key={feature.heading}
              number={String(index + 1).padStart(2, "0")}
              img={feature.image}
              heading={feature.heading}
              title={feature.description}
            />
          ))}
        </div>

        <div className="mt-8 flex flex-col gap-5 rounded-[26px] border border-white/10 bg-white/[0.055] p-6 backdrop-blur-xl sm:flex-row sm:items-center sm:justify-between md:p-7">
          <div className="flex items-start gap-4">
            <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-xl bg-[#FFDB16] text-slate-950">
              <FiCheck className="h-5 w-5" />
            </span>
            <div>
              <h3 className="font-heading text-xl font-extrabold text-white">
                Need a feature tailored to your business?
              </h3>
              <p className="mt-1 text-slate-400">
                We can shape the right functionality around your users and goals.
              </p>
            </div>
          </div>
          <Link
            to="/contactus"
            className="group inline-flex min-h-[50px] shrink-0 items-center justify-center gap-2 rounded-full bg-[#FFDB16] px-6 py-3 font-bold text-slate-950 transition duration-300 hover:-translate-y-0.5 hover:bg-white"
          >
            Discuss your website
            <FiArrowUpRight className="h-5 w-5 transition-transform duration-300 group-hover:-translate-y-0.5 group-hover:translate-x-0.5" />
          </Link>
        </div>
      </div>
    </section>
  );
};

export default WebsiteFeature;
